import * as React from 'react';

// 다국어
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Button, Link, TextField, CssBaseline } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import sendFAQ from '../../utils/apis/community/sendFAQ';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

export default function ContactModal({ modalOpen, pContactHandleClose }) {
  // 다국어
  const { t, i18n } = useTranslation(['page']);
  const [contactUserName, setContactUserName] = React.useState('');
  const [contactUserEmail, setContactUserEmail] = React.useState('');
  const [contactUserNumber, setContactUserNumber] = React.useState('');
  const [contactDetail, setContactDetail] = React.useState('');

  const [emailSendLoading, setEmailSendLoading] = React.useState(false);

  const onUserNameWriteHandle = (e) => {
    setContactUserName(e.target.value);
    // console.log( { event, editor, data } );
  };
  const onUserMailWriteHandle = (e) => {
    setContactUserEmail(e.target.value);
    // console.log( { event, editor, data } );
  };
  const onUserNumberWriteHandle = (e) => {
    setContactUserNumber(e.target.value);
    // console.log( { event, editor, data } );
  };
  const onDetailWriteHandle = (e) => {
    setContactDetail(e.target.value);
    // console.log( { event, editor, data } );
  };

  const sendContact = async () => {
    if (contactUserName !== '' && contactUserEmail !== '' && contactUserNumber !== '' && contactDetail !== '') {
      pContactHandleClose();
      setEmailSendLoading(true);

      try {
        await sendFAQ({
          name: contactUserName,
          email: contactUserEmail,
          phone: contactUserNumber,
          content: contactDetail,
        });
        alert('문의 메일이 발송되었어요. \n 빠르게 검토 후 연락드릴게요!');
      } catch (e) {
        alert('Invalid Input');
      }
      setEmailSendLoading(false);
    }
  };

  const contactHandleClose = () => {
    pContactHandleClose();
  };

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={contactHandleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box
          sx={{
            ...modalStyle,
            width: 800,
            display: 'flex',
            flexDirection: 'column',
            padding: '60px',
            border: '1px solid #ddd',
            borderRadius: '40px',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '40px' }}>
            <h2 id="parent-modal-title">{t('빠른 문의하기')}</h2>
            <p style={{ marginTop: '10px' }}>{t('빠르게 검토 후 연락드릴게요!')}</p>
          </div>
          <div>
            <TextField
              required
              fullWidth
              id="inquiryname"
              name="inquiryname"
              onKeyUp={onUserNameWriteHandle}
              label={t('이름을 입력하세요.')}
            />
            <TextField
              sx={{ marginTop: '10px' }}
              required
              fullWidth
              onKeyUp={onUserMailWriteHandle}
              id="inquiryemail"
              name="inquiryemail"
              label={t('이메일 주소를 입력하세요.')}
            />
            <TextField
              sx={{ marginTop: '10px' }}
              required
              fullWidth
              onKeyUp={onUserNumberWriteHandle}
              id="inquiryphone"
              name="inquiryphone"
              label={t('연락처를 입력하세요.')}
            />
            <TextField
              sx={{ marginTop: '10px' }}
              required
              onKeyUp={onDetailWriteHandle}
              id="parent-modal-description"
              fullWidth
              multiline
              rows={10}
              label={t('문의 내용을 입력하세요.')}
            />
          </div>
          <div>
            <Link href="#">{t('개인정보취급방침')}</Link>
            {t('에 동의합니다.')}
          </div>
          <div style={{ marginTop: '40px', textAlign: 'center' }}>
            <Button variant="contained" onClick={sendContact}>
              {t('문의하기')}
            </Button>
          </div>
        </Box>
      </Modal>

      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 20 }} open={emailSendLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
